export default "__VITE_ASSET__CrZGp$Ks__"